import React, { useState, useEffect } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Button, Tooltip, Box, Typography
} from "@mui/material";
import { Edit, Delete, Add, ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import apiClient from './api/apiClient';

const Users = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      let response = await apiClient.get(`/users`);
      setUsers(response.data);
    } catch (error) {
      console.log("Error reading users");
    }
  };

  const handleAddUser = () => {
    navigate("/usermaintenance");
  };

  const handleEdit = (id) => {
    navigate(`/usermaintenance/${id}`);
  };

  const handleDelete = async(id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
//      setUsers(users.filter((user) => user.id !== id));
        try{
            let response = await apiClient.delete(`/users/${id}`);
            console.log("response")
            fetchUsers();
        }catch(error){
          alert(`Error Deleting ${error}` )
        }
    }
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous screen
  };

  return (
    <Box sx={{ width: "90%", margin: "auto", mt: 5 }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ ml: 1 }}>
          Users List
        </Typography>
      </Box>

      {/* Add User Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        <Tooltip title="Add User" arrow>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={handleAddUser}
          >
            Add
          </Button>
        </Tooltip>
      </Box>

      {/* Users Table */}
      <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: "auto" }}>
        <Table stickyHeader size="small"> {/* Makes rows shorter */}
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "20%" }}><strong>User ID</strong></TableCell>
              <TableCell sx={{ width: "60%" }}><strong>User Name</strong></TableCell>
              <TableCell sx={{ width: "20%" }}><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id} sx={{ height: 36 }}>
                <TableCell>{user.id}</TableCell>
                <TableCell>{user.name}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(user.id)}>
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(user.id)}>
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Users;
